export type PhoneType = 'mobile' | 'landline';

export interface PhoneValidationResult {
  valid: boolean;
  type: PhoneType | null;
}

const FORMATTING_CHARS = /[\s\-()]/g;
const COUNTRY_PREFIX = /^\+977/;
const DIGITS_ONLY = /^\d+$/;
const MOBILE_REGEX = /^(96|97|98)\d{8}$/;
const LANDLINE_REGEX = /^(?!96|97|98)\d{8}$/;

export function normalizePhone(raw: string): string {
  let value = raw.trim();
  value = value.replace(COUNTRY_PREFIX, '');
  value = value.replace(FORMATTING_CHARS, '');
  return value;
}

export function classifyPhone(raw: string): PhoneValidationResult {
  if (!raw || !raw.trim()) {
    return { valid: false, type: null };
  }

  const normalized = normalizePhone(raw);

  if (!DIGITS_ONLY.test(normalized)) {
    return { valid: false, type: null };
  }

  if (MOBILE_REGEX.test(normalized)) {
    return { valid: true, type: 'mobile' };
  }

  if (LANDLINE_REGEX.test(normalized)) {
    return { valid: true, type: 'landline' };
  }

  return { valid: false, type: null };
}

const PHONE_ERROR_MESSAGE =
  'Please enter a valid 10-digit mobile number starting with 96, 97, or 98, or a valid 8-digit landline number.';

/**
 * Ant Design Form.Item custom validator for Nepal phone numbers.
 * Use as: rules={[{ validator: phoneValidator }]}
 * For optional fields, wrap: rules={[{ validator: optionalPhoneValidator }]}
 */
export function phoneValidator(_rule: unknown, value: string): Promise<void> {
  if (!value || !value.trim()) {
    return Promise.reject(new Error('Phone number is required'));
  }
  const result = classifyPhone(value);
  if (!result.valid) {
    return Promise.reject(new Error(PHONE_ERROR_MESSAGE));
  }
  return Promise.resolve();
}

export function optionalPhoneValidator(_rule: unknown, value: string): Promise<void> {
  if (!value || !value.trim()) {
    return Promise.resolve();
  }
  const result = classifyPhone(value);
  if (!result.valid) {
    return Promise.reject(new Error(PHONE_ERROR_MESSAGE));
  }
  return Promise.resolve();
}
